<template>
  <div
    v-if="activeOrderType && isNotAnEmployee"
    class="wc-active-order-type-badge d-flex justify-content-center align-items-center"
  >
    <div
      class="wc-active-order-type-badge__icon d-flex justify-content-center align-items-center font-size-sm mr-2"
    >
      <WCSvgIcon name="basket-shopping" icon-size="md" />
    </div>
    <div class="wc-active-order-type-badge__content font-size-sm d-flex align-items-center">
      <div class="wc-active-order-type-badge__label mr-2">{{ $t('youAreShopping') }}</div>
      <div class="wc-active-order-type-badge__value" :title="activeOrderType.name">
        {{ activeOrderType.name }}
      </div>
    </div>
  </div>
</template>

<script>
import WCSvgIcon from '@/components/WCSvgIcon/WCSvgIcon.vue';
import OrderTypesMixin from '@/modules/orderTypes/mixins/OrderTypesMixin';
import EmployeeMixin from '@/modules/employee/mixins/EmployeeMixin';

export default {
  components: { WCSvgIcon },
  mixins: [OrderTypesMixin, EmployeeMixin],
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-active-order-type-badge {
  height: 2.125rem;
  background: var(--primary-lighter-9);
  color: var(--primary, $primary);
}

.wc-active-order-type-badge :deep(svg),
.wc-active-order-type-badge :deep(path) {
  fill: currentColor;
}

.wc-active-order-type-badge__label {
  font-weight: 400;
  white-space: nowrap;
}

.wc-active-order-type-badge__value {
  font-weight: 700;
  min-width: 0;
  max-width: 62vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wc-active-order-type-badge__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
